import { AxiosInstance } from 'axios';
import { toResponse } from '../../genericToResponse';
import { IParameter } from 'src/views/Admin/Parameters/types';

export default (api: AxiosInstance, url: string) => async (
  parameter: IParameter
) => {
  const response = await api.post(url, parameter);
  return toResponse(response.data) as IParameter;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/parameters/add.ts